import noop from "lodash/noop";

import { HomeTestID } from "@/constants/TestID";
import { UnencryptedStorageKey } from "@/hooks/useUnencryptedStorage";
import HomeResourcesCard, {
  HomeContentImage,
} from "@/ui/components/home/HomeResourcesCard";
import { FAIconName, Icon, Text } from "@/ui/core";
import { Box, HStack, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

const TestimonialTitle = "What Equip treatment looks like for real patients";
const BodyText = "We know recovery is possible.\nWe see it every day.";
const TestimonialUrl = "https://equip.health/patient-stories";

const TestimonialBlurb = () => {
  return (
    <Box bottom={18} left={18} position="absolute">
      <VStack
        backgroundColor={ColorToken.Primary100}
        borderRadius={12}
        gap={4}
        padding={12}
      >
        <Text
          color={ColorToken.NeutralBackgroundPrimary}
          testID={joinTestIDs(HomeTestID.TestimonialImage, "blurb-body")}
          variant="bodyMedium"
        >
          {BodyText}
        </Text>
        <HStack gap={6}>
          <Text
            color={ColorToken.NeutralBackgroundPrimary}
            testID={joinTestIDs(HomeTestID.TestimonialImage, "blurb-caption")}
            variant="captionMedium"
          >
            Hear real patient stories
          </Text>
          <Box onPress={noop}>
            <Icon
              color={ColorToken.NeutralBackgroundPrimary}
              name={FAIconName.ChevronRight}
              size="sm"
              testID={joinTestIDs(HomeTestID.TestimonialImage, "blurb-icon")}
            />
          </Box>
        </HStack>
      </VStack>
    </Box>
  );
};

const TestimonialImage = () => {
  return (
    <HomeResourcesCard
      analyticsSource="testimonial"
      analyticsTitle={TestimonialTitle}
      contentUrl={TestimonialUrl}
      storageKey={UnencryptedStorageKey.HomeTabTestimonalDismissed}
      testID={HomeTestID.TestimonialImage}
    >
      <HomeContentImage
        imageSource={require("@/assets/images/components/home_resources/testimonial-background.png")}
      >
        <TestimonialBlurb />
      </HomeContentImage>
    </HomeResourcesCard>
  );
};

export default TestimonialImage;
